import { getUserRole } from '../../../services/common/util';

/**
 * Evaluates role-based access for a field.
 * Returns 'visible', 'disabled', or 'hidden'.
 */
export function evaluateRoleAccess(fieldDef) {
    if (!fieldDef.roleAccess || fieldDef.roleAccess.length === 0) {
        return 'visible';
    }

    const currentRole = getUserRole();
    if (!currentRole) {
        return 'visible';
    }

    const roleRule = fieldDef.roleAccess.find(
        (ra) => ra.role.toLowerCase() === currentRole.toLowerCase()
    );

    if (roleRule) {
        return roleRule.permission;
    }

    // If no specific rule for this role, default to visible
    return 'visible';
}
